import React, { useState, useCallback } from 'react'
import styles from './styles.css'
import { logout } from 'App/helpers/meteor-apollo-accounts'
import PropTypes from 'prop-types'
import Button from '@orionx-dev/orionsoft-parts/lib/components/Button'
import { MdRepeat } from 'react-icons/md'
import gql from 'graphql-tag'
import { useApolloClient, useMutation } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import withMessage from '@orionx-dev/orionsoft-parts/lib/decorators/withMessage'

const RESEND_VERIFICATION_EMAIL_MUTATION = gql`
  mutation resendVerificationEmail {
    resendVerificationEmail {
      success
    }
  }
`

const Verify = ({ showMessage, message }) => {
  const client = useApolloClient()
  const navigate = useNavigate()
  const [resendVerificationEmail] = useMutation(RESEND_VERIFICATION_EMAIL_MUTATION)
  const [loadingResend, setLoadingResend] = useState(false)

  const resend = useCallback(async () => {
    setLoadingResend(true)
    try {
      await resendVerificationEmail()
      showMessage('Te reenviamos el email')
    } catch (error) {
      console.error(error)
      showMessage(error.message)
    }
    setLoadingResend(false)
  }, [resendVerificationEmail, showMessage])

  const logoutFunc = useCallback(async () => {
    await logout(client)
    navigate('/login')
  }, [client, navigate])

  const renderEmail = () => {
    const email = (message?.split('<')[1] || '').split('>')[0]
    return email
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>Para poder seguir debes verificar tu email</div>
      <div className={styles.email}>{renderEmail()}</div>
      <div className={styles.buttons}>
        <Button onClick={resend} loading={loadingResend}>
          <MdRepeat style={{ marginRight: 5 }} /> Reenviar email
        </Button>
      </div>
      <div className={styles.cancelButton}>
        <a onClick={logoutFunc}>Cancelar inicio de sesión</a>
      </div>
    </div>
  )
}

Verify.propTypes = {
  showMessage: PropTypes.func,
  message: PropTypes.string,
}

export default withMessage(Verify)
